import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PhotoCardsResult } from '../search-state/utils';
import useCustomerPhotosLoader from '../hooks/useCustomerPhotosLoader';

/**
 * Reusable customer photos grid component with infinite scroll
 * @param {Object} props - Component props
 * @returns {JSX.Element} Customer photos grid component
 */
const CustomerPhotosGrid = t0 => {
  const $ = _c(10);
  const {
    mobileItemsPerRow,
    selectedGridItem,
    updateSelectedGridItem,
    variant,
    onPhotoFound,
    filterState,
    filterActions
  } = t0;
  const {
    photos,
    hasMore,
    filterLoading,
    handleLoadMore
  } = useCustomerPhotosLoader(filterState, filterActions, onPhotoFound);
  let t1;
  if ($[0] !== filterLoading || $[1] !== filterState.isFiltered || $[2] !== handleLoadMore || $[3] !== hasMore || $[4] !== mobileItemsPerRow || $[5] !== photos || $[6] !== selectedGridItem || $[7] !== updateSelectedGridItem || $[8] !== variant) {
    t1 = <PhotoCardsResult hits={photos} hasMore={hasMore} loading={filterLoading} refine={handleLoadMore} mobileItemsPerRow={mobileItemsPerRow} selectedGridItem={selectedGridItem} updateSelectedGridItem={updateSelectedGridItem} variant={variant} hasFilters={filterState.isFiltered} />;
    $[0] = filterLoading;
    $[1] = filterState.isFiltered;
    $[2] = handleLoadMore;
    $[3] = hasMore;
    $[4] = mobileItemsPerRow;
    $[5] = photos;
    $[6] = selectedGridItem;
    $[7] = updateSelectedGridItem;
    $[8] = variant;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
CustomerPhotosGrid.propTypes = {
  mobileItemsPerRow: PropTypes.number.isRequired,
  selectedGridItem: PropTypes.object,
  updateSelectedGridItem: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
  onPhotoFound: PropTypes.func,
  filterState: PropTypes.object.isRequired,
  filterActions: PropTypes.object.isRequired
};
export default CustomerPhotosGrid;